import React, { useEffect, useState } from 'react';
import asyncBatch from 'async-batch';
import { useRecoilCallback } from 'recoil';
import { sleep } from '../../modules/Manage/pages/queue-edit-dialog/QueueEditForm';
import { Logger } from '../../../common/Logger';
import { GridRowData } from '@mui/x-data-grid';
import { AxiosResponse } from 'axios';
import { ModalWithStyles } from '../../components/modals/ModalWithStyles';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../../services/rest/makeAPIRequest';

interface IBusinessSMSDeleteDialog {
  selected: GridRowData[];
  setSelected: React.Dispatch<React.SetStateAction<GridRowData[]>>;
  show: boolean;
  onHide: () => void;
  userAtomContents: any;
  setRefetchToggleForBusinessSMS: any;
}

export function BusinessSMSDeleteDialog({
  selected,
  setSelected,
  show,
  onHide,
  userAtomContents,
  setRefetchToggleForBusinessSMS,
}: IBusinessSMSDeleteDialog) {
  const [fetchState, setFetchState] = useState({
    state: 'hasValue',
    message: '',
  });
  const deleteBusinessSMS = useRecoilCallback(({ snapshot }) => async () => {
    // if id not populated then create new queue
    const deleteResponses: AxiosResponse<any>[] = [];
    // show loading UI
    setFetchState({
      state: 'loading',
      message: '',
    });
    let errorMessage: any;
    // server request for update queues toggles
    // run as async since synchronous atom updates will only trigger one reload
    await asyncBatch(
      selected,
      async ({ id: businesssmsid }: { id: string }) => {
        // stop if error occurred
        if (!errorMessage) {
          const response = await snapshot.getPromise(
            // makePHPRequest({
            //   methodName: methodNameEnum.DELETE_QUEUE,
            //   payloadJsonString: JSON.stringify({
            //     queueid,
            //   }),
            // transactionId: uuidv4(), // generate uuid to break selector cache
            // })
            makeAPIRequest({
              endpoint: `${endpointEnum.BUSINESS_SMS_BY_BUSINESS}/${userAtomContents?.businessid}/${businesssmsid}`,
              // stage: 'itn',
              domain: process.env.VITE_APP_CDK_DOMAIN,
              method: 'delete',
              payload: {
                businessSMSId: businesssmsid,
                apikey: userAtomContents?.apikey,
                businessid: userAtomContents?.businessid,
                businessId: userAtomContents?.businessid,
              },
            })
            // generate uuid to break selector cache
          );
          deleteResponses.push(response);
          errorMessage = response?.data?.error;
          await sleep(100); // pause between calls to reduce load on database
        }
      },
      1 // one at a time
    );

    // clear selection and close modal on success
    if (!errorMessage) {
      // stop loading UI
      setFetchState({
        state: 'hasValue',
        message: '',
      });

      // clear selection
      setSelected([]);

      // refetch business queues
      setRefetchToggleForBusinessSMS({});

      // closing delete modal
      onHide();

      Logger.trace(
        {
          message: `Success deleteBusinessSMS[${selected.length}]`,
          deleteResponses,
        },
        'deleteBusinessSMS'
      );
    } else {
      // stop loading UI
      // set error message
      setFetchState({
        state: 'hasError',
        message: errorMessage,
      });

      // log error and stop loading on failed
      Logger.error(
        {
          message: `Failed deleteBusinessSMS[${selected.length}]`,
          errorMessage,
          deleteResponses,
        },
        'deleteBusinessSMS'
      );
    }
  });

  // if queues weren't selected we should close modal
  // for refreshing the page
  useEffect(() => {
    if (!selected || selected.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <ModalWithStyles
      onSubmit={deleteBusinessSMS}
      title="Delete Team SMS rule(s)"
      aria-labelledby="example-modal-sizes-title-md"
      show={show}
      onHide={onHide}
      isSubmitting={fetchState.state === 'loading'}
      isLoading={fetchState.state === 'loading'}
      size="xs"
      deleteDialog={true}
    >
      <>
        <p>
          You are about to delete {selected.length} Team SMS rule(s), this
          procedure is not reversible.
        </p>
        <p>Do you want to proceed?</p>
      </>
      {fetchState.state === 'hasError' && (
        <span>Error deleting team SMS rules...</span>
      )}
    </ModalWithStyles>
  );
}
